import React, { useState, useRef, useEffect } from "react";
import person from "./mock.json";
import useLoadMoreOnScroll from "react-hook-pagination";
import {
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  makeStyles,
  Divider
} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: "block"
  }
}));

const MaterialList = props => {
  const classes = useStyles();
  const fetchSize = 20;
  const limit = 1000;
  const ulElement = useRef();
  const [data, setData] = useState([]);
  const {
    start,
    end,
    isFetching,
    doneFetching,
    setIsFetching,
    forceDonefetching
  } = useLoadMoreOnScroll({
    fetchSize,
    scroller: ulElement,
    limit: limit,
    mode: "debug"
  });

  useEffect(() => {
    fetchHandler(start, end);
  }, [start, end]);

  /**
   *
   * @param {Number} start : Index to start fetching from or commonaly called 'Offset'
   * @param {Number} end : Last index
   */
  const fetchHandler = (start, end) => {
    console.log(start, end);
    console.log("fetching data...");
    setIsFetching(true);
    setTimeout(() => {
      setData([...data, ...person.slice(start, end)]);
      console.log("done fetching");
      setIsFetching(false);
    }, 2000);
  };
  const getInitials = (fn, ln) => {
    return fn.toUpperCase().substring(0, 1) + ln.toUpperCase().substring(0, 1);
  };
  return (
    <List ref={ulElement} style={{ height: "400px", overflow: "auto" }}>
      {data.map((i, idx) => (
        <React.Fragment key={idx}>
          <ListItem button>
            <ListItemAvatar>
              <Avatar alt="Remy Sharp">
                {getInitials(i.first_name, i.last_name)}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={`${i.first_name} ${i.last_name}`}
              secondary={
                <Typography
                  component="span"
                  variant="body2"
                  color="textSecondary"
                  className={classes.inline}
                >
                  {i.email}
                </Typography>
              }
            ></ListItemText>
          </ListItem>
          <Divider variant="inset" component="li" />
        </React.Fragment>
      ))}

      {isFetching && <div key={-1} className="list-item-loader"></div>}
    </List>
  );
};
export default MaterialList;
